var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"green-text",on:{"click":function($event){return _vm.$emit('onClick')}}},[_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"green-text__plus",class:_vm.isOpen && 'green-text__plus--open'})]),_c('div',{staticClass:"d-flex align-center"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }